import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackLoginView = (): void => {
  trackingService.trackEvent(
    'SIGN_IN',
    PRODUCT_NAME,
    {
      page: 'login',
      route: '/login',
      placement: '',
      surface: '',
      flow: 'login',
      step: 'login e senha',
      element: '',
      action: 'view',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackLoginHelp = (): void => {
  trackingService.trackEvent(
    'HELP',
    PRODUCT_NAME,
    {
      page: 'login',
      route: '',
      placement: 'header',
      surface: '',
      flow: 'ajuda',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackLoginForgotPassword = (): void => {
  trackingService.trackEvent(
    'FORGOT_PASSWORD',
    PRODUCT_NAME,
    {
      page: 'login',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'esqueceu senha',
      step: 'inicio',
      element: 'link',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackLoginSubmit = (): void => {
  trackingService.trackEvent(
    'SIGN_IN',
    PRODUCT_NAME,
    {
      page: 'login',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'login',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackLoginSignUp = (): void => {
  trackingService.trackEvent(
    'SIGN_UP',
    PRODUCT_NAME,
    {
      page: 'login',
      route: '',
      placement: 'main',
      surface: '',
      flow: 'login',
      step: 'iniciar cadastro',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackLoginGooglePlay = (): void => {
  trackingService.trackEvent(
    'GOOGLE_PLAY',
    PRODUCT_NAME,
    {
      page: 'login',
      route: '',
      placement: 'footer',
      surface: '',
      flow: 'login',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackLoginAppStore = (): void => {
  trackingService.trackEvent(
    'APP_STORE',
    PRODUCT_NAME,
    {
      page: 'login',
      route: '',
      placement: 'footer',
      surface: '',
      flow: 'login',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
